<div class="wvCount" [ngClass]="hasBackdrop ? 'wvCustomItemDark' : 'wvCustomItemLight'" *ngIf="!slideError">
    <div class="wvAgentCounterText textArea" *ngIf="agentCounterState?.CounterTitle != null && agentCounterState?.CounterTitle != ''">
        <div [ngClass]="'agentTitle' + moduleKey">{{agentCounterState?.CounterTitle}}</div>
    </div>

    <div class="wallboardSetupCustomCounterDataContainer"
         [ngClass]="{ None: !agentCounterState?.ShowLabels && agentCounterState?.CounterTitle == '', Label: !agentCounterState?.ShowLabels && agentCounterState?.CounterTitle != '', Legend: agentCounterState?.ShowLabels && agentCounterState?.CounterTitle == '', Both: agentCounterState?.ShowLabels && agentCounterState?.CounterTitle != '' }">
        <div class="wallboardSetupAgentCounterTotalLabel" [ngClass]="'actot' + moduleKey">{{agentCounterData?.TotalCount}}</div>
        <canvas [ngClass]="'chart' + moduleKey"></canvas>
    </div>

    <div class="wallboardSetupCustomCounterLegend FlexColNoWrap" *ngIf="agentCounterState?.ShowLabels">
        <div class="FlexRowNoWrap justify-content-between">
            <div class="FlexRowNoWrap" style="flex:1">
                <div class="legendItem red FlexAlignVertical"></div>
                <div class="legendText" [ngClass]="'acleg' + moduleKey">{{agentCounterData?.AgentStateCategories?.[AgentStateTypeEnum?.Unavailable]}}</div>
            </div>

            <div class="FlexRowNoWrap" style="flex:1">
                <div class="legendItem yellow FlexAlignVertical"></div>
                <div class="legendText" [ngClass]="'acleg' + moduleKey">{{agentCounterData?.AgentStateCategories?.[AgentStateTypeEnum?.Outbound]}}</div>
            </div>

            <div class="FlexRowNoWrap justify-content-end" style="flex:1">
                <div class="legendItem purple FlexAlignVertical"></div>
                <div class="legendText" [ngClass]="'acleg' + moduleKey">{{agentCounterData?.AgentStateCategories?.[AgentStateTypeEnum?.Inbound]}}</div>
            </div>
        </div>

        <div class="FlexRowNoWrap justify-content-between">
            <div class="FlexRowNoWrap justify-content-end" style="flex:1">
                <div class="legendItem orange FlexAlignVertical"></div>
                <div class="legendText" [ngClass]="'acleg' + moduleKey">ACW</div>
            </div>

            <div class="FlexRowNoWrap justify-content-end" style="flex:1">
                <div class="legendItem green FlexAlignVertical"></div>
                <div class="legendText" [ngClass]="'acleg' + moduleKey">{{agentCounterData?.AgentStateCategories?.[AgentStateTypeEnum?.Available]}}</div>
            </div>

            <div class="FlexRowNoWrap justify-content-end" style="flex:1">
                <div class="legendItem FlexAlignVertical"></div>
                <div class="legendText" [ngClass]="'acleg' + moduleKey"></div>
            </div>
        </div>
    </div>
</div>

<div class="wvCustomItem wvSlideError d-flex" *ngIf="slideError">
    <div class="sadErrorBox">
        <div class="errorCharacter"></div>

        <div class="errorText d-inline-block">
            <div cvLocalizedText langSection="Wallboard_Display" langKey="Uh_Oh">Uh Oh</div>
            <div cvLocalizedText langSection="Wallboard_Display" langKey="Something_Went_Wrong">Something went wrong</div>
        </div>
    </div>
</div>
